import React from 'react';
import moment from 'moment-timezone';

const dateRangeFormat = (date) => <span className="bold">{moment.unix(date).format("D MMMM YYYY")}</span>;

export const DateRange = ({startDate, endDate}) => (
  <span>from {dateRangeFormat(startDate)} to {dateRangeFormat(endDate)}</span>
);



// WEBPACK FOOTER //
// ./src/components/common/dateRange/dateRange.js